<template>
  <div>
    <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-custom-yellow"></div>
    </div>
    <template v-else>
      <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5">
        <table class="w-full text-left rtl:text-right text-gray-700">
          <thead>
            <tr class="bg-gray-100">
              <th scope="col" class="p-4">
                <div class="flex items-center">
                  <input
                    id="checkbox-all-search"
                    type="checkbox"
                    class="w-4 h-4 text-custom-yellow bg-gray-100 border-gray-300 rounded focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label for="checkbox-all-search" class="sr-only">checkbox</label>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Requesting Facility
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Facility Contact
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Date Requested
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Date Required
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Quantity Requested
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Status
                  <a href="#">
                    <svg
                      class="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
                      />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" class="px-6">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(requisition_data, index) in filteredRequests"
              :key="index"
              class="border-b"
            >
              <td class="w-4 p-4">
                <div class="flex items-center">
                  <input
                    :id="'checkbox-table-search-' + index"
                    type="checkbox"
                    class="w-4 h-4"
                  />
                  <label
                    :for="'checkbox-table-search-' + index"
                    class="sr-only"
                  >
                    checkbox
                  </label>
                </div>
              </td>
              <td class="px-6 py-1">
                {{ requisition_data.requesting_facility?.name || 'N/A' }}
              </td>
              <td class="px-6 py-1">
                {{ requisition_data.requesting_facility?.contact_person_phone || 'N/A' }}
              </td>
              <td class="px-6 py-1">
                {{ formatDateISO(requisition_data.created_at) }}
              </td>
              <td class="px-6 py-1">
                {{ formatDateISO(requisition_data.date_required) }}
              </td>
              <td class="px-6 py-1">
                {{ calculateTotalRequestedQuantity(requisition_data) }}
              </td>
              <td class="px-6 py-1">
                <span
                  class="inline-flex justify-center px-2.5 py-1 w-full rounded-md"
                  :class="{
                    'bg-green-200 text-green-800': requisition_data.status === 'Completed',
                    'bg-yellow-200 text-yellow-600': requisition_data.status === 'Pending',
                    'bg-blue-200 text-blue-800': requisition_data.status === 'Partially Issued',
                    'bg-red-200 text-red-800': requisition_data.status === 'Rejected',
                    'bg-gray-200 text-gray-800': !['Completed', 'Pending', 'Partially Issued', 'Rejected'].includes(requisition_data.status)
                  }"
                >
                  {{ requisition_data.status }}
                </span>
              </td>
              <td class="flex items-center px-4 py-2">
                <CustomButton
                  label="View Details"
                  @click="redirectToRequestDetails(requisition_data.ecosystem_request_id)"
                  :disabled="isLoading[requisition_data.ecosystem_request_id]"
                  :bg-class="isLoading[requisition_data.ecosystem_request_id] ? 'bg-gray-300 cursor-not-allowed' : 'bg-custom-yellow py-1'"
                />
                <div
                  v-if="isLoading[requisition_data.ecosystem_request_id]"
                  class="ml-2 animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-gray-900"
                ></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="text-center text-gray-600 mb-2">{{ showingText }}</p>
      <div class="flex justify-center gap-4 mt-4">
        <button
          @click="previousPage"
          :disabled="currentPage === 1"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
        >
          <svg
            class="w-6 h-6"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m15 19-7-7 7-7"
            />
          </svg>
          Previous
        </button>
        <div class="flex items-center gap-2">
          <button
            v-for="page in visiblePages"
            :key="page"
            @click="goToPage(page)"
            :class="{
              'bg-custom-blue text-white': page === currentPage,
              'text-custom-blue': page !== currentPage
            }"
            class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button"
          >
            <span
              class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
            >
              {{ page }}
            </span>
          </button>
        </div>
        <button
          @click="nextPage"
          :disabled="currentPage === totalPages"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button"
        >
          Next
          <svg
            class="w-6 h-6"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m9 5 7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import api from "@/services/api";
import SweetAlertService from '@/services/SweetAlertService';

export default {
  name: "FacilityRequestTab",
  components: {
    CustomButton,
  },
  props: {
    searchQuery: {
      type: String,
      default: ''
    },
    filters: {
      type: Object,
      default: () => ({
        blood_group: '',
        status: '',
        unit_product: '',
        start_date: '',
        end_date: ''
      })
    }
  },
  data() {
    return {
      facility_requests: [],
      error: null,
      isLoading: {},
      loading: false,
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      totalCount: 0,
      selectedRequest: null,
      facility_logo: '',
      localSearchQuery: '',
    };
  },
  computed: {
    filteredRequests() {
      return this.facility_requests;
    },
    visiblePages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const delta = 2;
      const range = [];
      const rangeWithDots = [];
      let l;

      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
          range.push(i);
        }
      }

      range.forEach(i => {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push('...');
          }
        }
        rangeWithDots.push(i);
        l = i;
      });

      return rangeWithDots;
    },
    showingText() {
      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = start + this.filteredRequests.length - 1;
      return `Showing ${start}-${end} of ${this.totalCount}`;
    }
  },
  created() {
    this.user = this.$store.getters["auth/user"];
    this.facility_logo = this.user.user_roles[0]?.facility_department?.facility?.logo;
    this.localSearchQuery = this.searchQuery;
    this.getFacilityRequests();
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.currentPage = 1;
        this.getFacilityRequests();
      }
    },
    searchQuery: {
      handler(newVal) {
        this.localSearchQuery = newVal;
        this.currentPage = 1;
        this.getFacilityRequests();
      },
      immediate: true
    },
    localSearchQuery: {
      handler(newVal) {
        this.$emit('update:searchQuery', newVal);
        this.currentPage = 1;
        this.getFacilityRequests();
      }
    }
  },
  methods: {
    async getFacilityRequests() {
      this.loading = true;
      try {
        const queryParams = {
          blood_group: this.filters.blood_group,
          status: this.filters.status,
          unit_product: this.filters.unit_product,
          start_date: this.filters.start_date,
          end_date: this.filters.end_date,
          search_query: this.localSearchQuery,
          page: this.currentPage,
          per_page: this.perPage
        };

        const response = await api.getEcosystemBloodRequests(queryParams);
        this.facility_requests = response.data || [];
        this.currentPage = response.current_page || 1;
        this.totalPages = response.total_pages || 1;
        this.totalCount = response.total_count || 0;
      } catch (error) {
        this.error = error.message || "Failed to fetch facility requests";
        SweetAlertService.showError('Error', this.error);
      } finally {
        this.loading = false;
      }
    },
    async redirectToRequestDetails(id) {
      this.isLoading[id] = true;
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$router.push({
          name: "EcosystemRequestsDetailsPage",
          params: { ecosystem_request_id: id },
        });
      } catch (error) {
        console.error('Error redirecting:', error);
        SweetAlertService.showError('Error', 'Failed to load request details');
      } finally {
        this.isLoading[id] = false;
      }
    },
    applyFilters() {
      this.currentPage = 1;
      this.getFacilityRequests();
    },
    cancelFilters() {
      this.$emit('cancel-filters');
      this.currentPage = 1;
      this.getFacilityRequests();
    },
    goToPage(page) {
      if (page !== '...' && page !== this.currentPage) {
        this.currentPage = page;
        this.getFacilityRequests();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getFacilityRequests();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getFacilityRequests();
      }
    },
    formatDateISO(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    },
    calculateTotalRequestedQuantity(requisition) {
      if (!requisition?.ecosystem_products || requisition.ecosystem_products.length === 0) {
        return "0 units";
      }
      const totalQuantity = requisition.ecosystem_products.reduce((sum, product) => {
        const quantity = parseInt(product.requested_quantity, 10);
        return sum + (isNaN(quantity) ? 0 : quantity);
      }, 0);
      return `${totalQuantity} units`;
    },
  },
};
</script>

<style lang="css" scoped>
</style>